import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import find from 'lodash/find';
import { DEFAULT_ASPECT_RATIOS, IAspectRatioInfo } from '../../../constants/common.constants';

export interface UiCropImageAdvancedModalConfig {
  imgUrl: string;
  aspectRatios: IAspectRatioInfo[];
  selectedAspectRatioId: string;
  enableResize: boolean;
  keepBgTransparent?: boolean;
  fitIntoAspectRatio?: boolean;
  showGuide?: boolean;
  maxImageSize?: number;
}

@Component({
  standalone: false,
  templateUrl: './ui-crop-image-advanced-modal.component.html',
  styleUrls: ['./ui-crop-image-advanced-modal.component.scss']
})
export class UiCropImageAdvancedModalComponent implements OnInit, UiCropImageAdvancedModalConfig {

  @Input() imgUrl: string;

  @Input() maxImageSize?: number;
  @Input() resultImgUrl: string;
  @Input() file: File;
  @Input() aspectRatios: IAspectRatioInfo[];
  @Input() enableResize: boolean;
  @Input() selectedAspectRatioId: string;
  @Input() keepBgTransparent: boolean;
  @Input() showGuide: boolean = true;
  @Input() fitIntoAspectRatio: boolean = false;

  public selectedAspectRatio: any;

  constructor(public modal: NgbActiveModal) {
  }

  ngOnInit() {
    this.aspectRatios = this.aspectRatios ? this.aspectRatios : DEFAULT_ASPECT_RATIOS;
    this.selectedAspectRatio = find(this.aspectRatios, { id: this.selectedAspectRatioId }) || null;
  }

  uploadImage() {
    this.modal.close(this.selectedAspectRatio
      ? this.resultImgUrl
      : this.imgUrl);
  }

  onResultUrlChanged(url: string) {
    this.resultImgUrl = url;
  }
}
